import React from 'react';
import Form from 'react-bootstrap/Form';
import { useForceUpdate } from '../util';
import CodeEditor from '@uiw/react-textarea-code-editor';
import { TabContextReporter } from '../TabContext';
export default function TaskCustom(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  return /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "Code Editor"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(CodeEditor, {
    value: dataProps.inner,
    language: "html",
    onChange: e => {
      dataProps.inner = e.target.value;
      forceUpdate();
      props.onChanged();
    },
    className: "richtext"
  })));
}